/**
 * Configuration context for React application.
 *
 * Provides application configuration to all components via React Context.
 * Configuration is loaded from the backend `/api/config` endpoint on app initialization.
 */

import { createContext, use } from 'react'
import type { Config } from '@/types/config'

export const ConfigContext = createContext<Config | null>(null)

/**
 * Hook to access application configuration from anywhere in the React component tree.
 *
 * @throws Error if used outside ConfigProvider
 */
export function useConfig(): Config {
  const config = use(ConfigContext)

  if (!config) {
    throw new Error(
      'useConfig() must be used within a ConfigProvider. ' +
        'Wrap your app with <ConfigProvider> at the root level.',
    )
  }

  return config
}
